import styled from 'styled-components';

import { subtitleStyle } from '@front/common/src/components/screen/styles';

export const SubtitleContainer = styled.div`
  display: inline-block;
  ${subtitleStyle};
`;
